import {
  CREATE_REGISTRATION_REQUEST,
  CREATE_REGISTRATION_SUCCESS,
  CREATE_REGISTRATION_FAILURE
} from '../actions/registrations';

const registrations = (state = [], action) => {
  switch (action.type) {
    case CREATE_REGISTRATION_REQUEST:
      return {
        ...state,
        error: false
      };
    case CREATE_REGISTRATION_SUCCESS:
      return {
        ...state,
        user: action.user,
        error: false
      };
    case CREATE_REGISTRATION_FAILURE:
      return {
        ...state,
        error: true
      };
    default:
      return state;
  }
};

export default registrations;



// WEBPACK FOOTER //
// ./src/reducers/registrations.js